import React from 'react';


const Work = () => {
  return (
    <div>
      <div class="container-fluid mb-5" id="projects">
        <h1
          class="text-center font-weight-bold"
          style={{ marginTop: '25%', textDecoration: 'underline' }}
        >
          PERSONAL WORK
        </h1>
        <div class="row bg-dark" style={{ marginTop: '2%' }}>
          <div class="col-md-4 mt-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164887/Portfolio/basketball-challenge_fpkkso.png" alt="" class="img-fluid" />
          </div>
          <div class="col-md-4 mt-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164888/Portfolio/college_website_sy3kmm.png" alt="" class="img-fluid" />
          </div>
          <div class="col-md-4 mt-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164887/Portfolio/covid_i4riov.png" alt="" class="img-fluid" />
          </div>

          <div class="col-md-4 mt-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164889/Portfolio/food-ordering_wfemo8.png" alt="" class="img-fluid" />
          </div>

          <div class="col-md-4 mt-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164890/Portfolio/gym_zwfbtg.png" alt="" class="img-fluid" />
          </div>

          <div class="col-md-4 mt-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164889/Portfolio/keep-notes_vywgrc.png" alt="" class="img-fluid" />
          </div>

          <div class="col-md-4 offset-md-4 mt-5 mb-5">
            <img src="https://res.cloudinary.com/kkamal714/image/upload/v1593164888/Portfolio/todo_zoal7s.png" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Work;
